import { render, staticRenderFns } from "./CstBdAreaList.vue?vue&type=template&id=019ac0eb&scoped=true&xmlns%3Abackground-color=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./CstBdAreaList.vue?vue&type=script&lang=js&"
export * from "./CstBdAreaList.vue?vue&type=script&lang=js&"
import style0 from "./CstBdAreaList.vue?vue&type=style&index=0&id=019ac0eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019ac0eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('019ac0eb')) {
      api.createRecord('019ac0eb', component.options)
    } else {
      api.reload('019ac0eb', component.options)
    }
    module.hot.accept("./CstBdAreaList.vue?vue&type=template&id=019ac0eb&scoped=true&xmlns%3Abackground-color=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&", function () {
      api.rerender('019ac0eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/CstBdAreaList.vue"
export default component.exports